import React, { useState, useEffect, useRef } from 'react'
import styles from './auth.module.scss'
import API from '../utils/API'
import { strings } from '../utils/translations'
import Loader from '../Loader'
import { QrCode } from "react-qrcode-pretty"
import AppIconGlass from '../../img/app_icon_glass.png'
import Button from '../Button/button'
import history from '../utils/routes/history'
import { notification } from 'antd'

const REGENERATE_QR_TIMER = 3.9*60 // in seconds

const QRLogin = (props) =>
{
    const [isLoading, setIsloading] = useState(false)
    const [hasError, setHasError] = useState(false)
    const [qrExpired, setQrExpired] = useState(false)
    const [loginToken, setLoginToken] = useState(null)
    const regenerateQrTimer = useRef(null)
    
    useEffect(() => {
        getQrLoginToken()
    }, [])
    
    const getQrLoginToken = async () =>
    {
        if (isLoading) return
        
        setLoginToken(null)
        setHasError(false)
        setQrExpired(false)
        setIsloading(true)
        
        try
        {
            let res = await API.getInstance().getQrLoginToken()
            setLoginToken(res?.data?.token)
            
            startRegenerateQrTimer(res?.data?.token)
        }
        catch(error)
        {
            console.dir(error)
            
            setHasError(true)
            stopRegenerateQrTimer()
            
            // Rate limit exceeded
            if (error?.response?.status === 429)
            {
                notification.error({
                   message: strings('errorWord'),
                   description: strings('qrLoginError429'),
                   placement: 'top',
                   duration: 6
               })
            }
            else
            {
                notification.error({
                   message: strings('errorWord'),
                   description: strings('qrLoginErrorCreateQr'),
                   placement: 'top',
                   duration: 6
               })
            }
        }
        finally
        {
            setIsloading(false)
        }
    }
    const getQrData = () =>
    {
        return `tesla/${API.getInstance().getDeviceId()}/${loginToken?.timestamp}/${loginToken?.token}`
    }
    const getQrAccessToken = async () =>
    {
        setIsloading(true)
        
        try
        {
            let res = await API.getInstance().getQrAccessToken(loginToken?.timestamp, loginToken?.token)
            
            goToGarages(res?.data?.tokenInfo?.token, res?.data?.tokenInfo?.userId)
        }
        catch(error)
        {
            console.dir(error)
            
            setIsloading(false)
            
            notification.error({
                message: strings('errorWord'),
                description: strings('qrLoginErrorGetAccessToken'),
                placement: 'top',
                duration: 6
            })
           
            stopRegenerateQrTimer()
            getQrLoginToken()
        }
    }
    
    const onPressAlreadyScannedIt = () =>
    {
        getQrAccessToken()
    }
    const onPressRetry = () =>
    {
        getQrLoginToken()
    }
    const onPressRefreshQr = () =>
    {
        getQrLoginToken()
    }
    
    const startRegenerateQrTimer = (loginToken) =>
    {
        stopRegenerateQrTimer()
        
        regenerateQrTimer.current = setTimeout(() =>
        {
            // Check first if current QR is validated
            API.getInstance().getQrAccessToken(loginToken?.timestamp, loginToken?.token)
            .then(res =>
            {
                goToGarages(res?.data?.tokenInfo?.token, res?.data?.tokenInfo?.userId)
            })
            .catch(error =>
            {
                console.dir(error)
                
                setQrExpired(true)
            })
            
        }, REGENERATE_QR_TIMER*1000)
    }
    const stopRegenerateQrTimer = () =>
    {
        if (regenerateQrTimer?.current != null)
        {
            clearTimeout(regenerateQrTimer?.current)
            regenerateQrTimer.current = null
        }
    }
    
    const goToGarages = (token, userId) =>
    {
        stopRegenerateQrTimer()
        
        API.getInstance().setExternalAccessToken(token, userId)
        history.push("/garages")
        
        // Save Tesla login setting
        localStorage.setItem('_tesla', true)
        const expires = "; expires=Fri, 31 Dec 2030 23:59:59 GMT; path=/"
        document.cookie = "_tesla=" + true + expires
    }
    
    
    return (
        <div className={styles.qrLogin}>
            <div className={styles.titleContainer}>
                <h3>{ strings('qrLogin') }</h3>
            </div>
            
            <div className={styles.verifyContainer}>
                <p className={styles.descriptionText} style={{textAlign: 'center'}}>
                    { strings('qrLoginDescription') }
                </p>
            </div>
            
            {
                isLoading ?
                <Loader
                    className={styles.loader}
                    isLoading
                    gray
                    large
                    spinner
                    fullWidth
                />
                :
                <div className={styles.qrCode}>
                    {
                        loginToken != null ?
                        <>
                            <div className={styles.qrContent}>
                                <QrCode
                                    value={getQrData()}
                                    variant={'fluid'}
                                    color={'rgb(44,44,46)'}
                                    padding={64}
                                    image={AppIconGlass}
                                    bgRounded
                                />
                                {
                                    qrExpired &&
                                    <div className={styles.expiredView}>
                                        <div className={styles.descriptionText}>
                                            { strings('qrLoginCodeExpired') }
                                        </div>
                                        <Button
                                            title={strings('refresh')}
                                            smaller
                                            className={styles.button}
                                            onClick={onPressRefreshQr}
                                        />
                                    </div>
                                }
                            </div>
                            {
                                !qrExpired &&
                                <Button
                                    title={strings('iAlreadyScannedIt')}
                                    smaller
                                    className={styles.button}
                                    onClick={onPressAlreadyScannedIt}
                                />
                            }
                        </>
                        :
                        (
                            (hasError || qrExpired) &&
                            <Button
                                title={strings('retry')}
                                smaller
                                className={styles.button}
                                onClick={onPressRetry}
                            />
                        )
                    }
                </div>
            }
        </div>
    )
}

export default QRLogin